import { Icon } from "@mui/material";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import bgSignIn from "assets/images/orli-bg-blue.png";
import { TbWorldExclamation } from "react-icons/tb";
import useCommon from "hooks/useCommon";

function NotFound() {
  const { NAVIGATE } = useCommon();

  return (
    <CoverLayout title="" description="">
      <VuiBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        minHeight="75vh"
        px={3}
      >
        <VuiBox
          sx={{
            position: "absolute",
            width: "300px",
            height: "300px",
            background: "rgba(0, 157, 255, 0.15)",
            borderRadius: "50%",
            filter: "blur(120px)",
            zIndex: 0,
          }}
        />

        <VuiTypography
          variant="h1"
          fontWeight="bold"
          color="primary"
          sx={{
            fontSize: "120px",
            lineHeight: 1,
            // background: "linear-gradient(135deg, #00c6ff, #0072ff)",
            // WebkitBackgroundClip: "text",
            // WebkitTextFillColor: "transparent",
            mb: 3,
            zIndex: 1,
          }}
        >
          404
        </VuiTypography>

        <VuiBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1.5}
          mb={2}
          sx={{ zIndex: 1 }}
        >
          {/* <TbWorldExclamation size={26} color="#fff" /> */}

          <VuiTypography variant="h3" fontWeight="medium">
            Lost in Space?
          </VuiTypography>
        </VuiBox>

        <VuiTypography
          variant="button"
          fontWeight="regular"
          sx={{
            maxWidth: "500px",
            opacity: 0.85,
            mb: 4,
            zIndex: 1,
          }}
        >
          The page you're trying to reach doesn't exist or may have been moved. Let's get you back
          to where you belong.
        </VuiTypography>

        <VuiButton
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => NAVIGATE("/authentication/sign-in")}
          sx={{
            px: 5,
            py: 1.5,
            fontSize: "14px",
            borderRadius: "12px",
            zIndex: 1,
          }}
        >
          Return to Sign In
        </VuiButton>
      </VuiBox>
    </CoverLayout>
  );
}

export default NotFound;
